import getCurrencySymbol from '../../../../../shared/utils/getCurrencySymbol';
import { UNDISCLOSED_EVENT_VALUE } from '../../support/utils/eo_constants';

// biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
export const currencyFormatter = (value, i?, data?) => {
  if (value === UNDISCLOSED_EVENT_VALUE) {
    return UNDISCLOSED_EVENT_VALUE;
  }
  return `${getCurrencySymbol(data?.localCurrency || 'USD')}${(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
